import styled from "styled-components";

interface RowProps {
  readonly $isEven: boolean;
}
export const Row = styled.div<RowProps>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem 1rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  background: ${({ $isEven }) => ($isEven ? "rgba(0,0,0,0.03)" : "rgba(0,0,0,0.06)")};
`;

interface BadgeProps {
  readonly $type: "loan" | "card";
}
export const TypeBadge = styled.span<BadgeProps>`
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  background: ${({ $type }) => ($type === "loan" ? "rgba(33, 150, 243, 0.12)" : "rgba(76, 175, 80, 0.12)")};
  color: ${({ $type }) => ($type === "loan" ? "#1565c0" : "#2e7d32")};
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
`;

export const LeaBankBadge = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 152, 0, 0.12);
  color: #bf360c;
  font-size: 12px;
  font-weight: 600;
`;

export const AmountCell = styled.div`
  text-align: right;
  font-variant-numeric: tabular-nums;
`;

export const SummaryBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 12px;
  opacity: 0.8;
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem 1rem;
  align-items: center;
  padding: 0 0.75rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  opacity: 0.7;
`;

export const HeaderAmount = styled.div`
  text-align: right;
`;

export const Rows = styled.div`
  display: grid;
  row-gap: 0.25rem;
`;
